
import { Component, Vue } from 'vue-property-decorator'
import TicketGygl from '@/views/Ticket/indexGygl.vue'

@Component({
  name: 'AllMyOrderLists',
  components: {
    TicketGygl
  }
})
export default class extends Vue {}
